export const encryptHash = (screenId, verificationId, displayToken) => {
  const info = `${screenId}.${verificationId}`;
  const encoding = btoa(displayToken); // Encode the display token
  let result = btoa(`${encoding}.${info}`); // Add and encode to the other data

  if (result.indexOf('=') !== -1) {
    ([result] = result.split('='));
  }

  return result;
};

export const decryptHash = (hash) => {
  try {
    // Restore stripped base64 padding before decoding
    const padded = hash + '='.repeat((4 - (hash.length % 4)) % 4);
    let result = atob(padded).split('.');
    result[0] = atob(result[0]);
    return { screen_id: result[1], verification_id: result[2], display_token: result[0] };
  } catch (err) {
    console.error('Failed to decrypt hash:', err);
    return {};
  }
};
